import { InternalAssessmentGroupRow, InternalAssessmentGroupRowTableModel } from "./InternalAssessmentGroups.types";
import { SelectableAssignee } from "./SelectableAssignee.types";
import { SelectableItem } from "../processingActivity/ProcessingActivity.types";
import { toAuditGroupTableRows } from "@common/components/questionnaireComponents/auditGroupTable/AuditGroupTable.columns";

type TranslateDate = (date: Date, options?: Intl.DateTimeFormatOptions) => string;

// A draft has never been sent, so it carries no year and drops out as soon as the sent filter is used.
// A group sent on behalf of the whole group has no sender of its own, which the empty id stands for - the list
// shows the customer name there.
export const groupFilterCandidates = [
    { id: "questionnaires", candidate: (row: InternalAssessmentGroupRowTableModel) => row.questionnaire.id },
    { id: "responsibles", candidate: (row: InternalAssessmentGroupRowTableModel) => row.responsible.id },
    { id: "deadlines", candidate: (row: InternalAssessmentGroupRowTableModel) => new Date(row.deadline).getTime().toString() },
    { id: "yearsSent", candidate: (row: InternalAssessmentGroupRowTableModel) => (row.sent ? new Date(row.sent).getFullYear().toString() : null) },
    { id: "assignees", candidate: (row: InternalAssessmentGroupRowTableModel) => row.assigneeIds },
    { id: "senders", candidate: (row: InternalAssessmentGroupRowTableModel) => row.senderId ?? "" },
];

/**
 * The business area filter is absolute: legal entity contacts hold no business areas, so choosing one removes
 * every contact from the list until the filter is cleared. Only external users can ever match.
 */
export const assigneeFilterCandidates = [
    { id: "businessAreas", candidate: (row: SelectableAssignee) => row.businessAreas.map((businessArea) => businessArea.id) },
    { id: "recipientTypes", candidate: (row: SelectableAssignee) => row.assigneeType.toString() },
];

export function toDistinctOptions(options: Array<SelectableItem>) {
    return options
        .filter((option, index, all) => all.findIndex((other) => other.id === option.id) === index)
        .sort((first, second) => first.name.localeCompare(second.name));
}

/**
 * Mirrors the backend guard in InternalAssessmentGroupHandler.DeleteGroup, which refuses the delete once the
 * group holds a submitted assessment, because deleting the group would destroy the answers. The group overview
 * gets the same answer straight off its view model; the list only carries the counts, and submittedCount is the
 * same "submitted and not closed" predicate the guard uses.
 */
export function canDeleteGroup(row: InternalAssessmentGroupRow) {
    return row.submittedCount === 0;
}

export function toGroupTableModel(rows: Array<InternalAssessmentGroupRow>, translateDate: TranslateDate): Array<InternalAssessmentGroupRowTableModel> {
    return toAuditGroupTableRows(rows, translateDate);
}
